import { Icon } from './icons'
import { Avatar } from './shared'
import type { Role, Server, User } from './types'

interface TopbarProps {
  route: string
  servers: Server[]
  role: Role
  viewer: User | null
  onMenuClick: () => void
}

function titleFor(route: string, servers: Server[]): string {
  if (route.startsWith('srv:')) {
    const id = route.split(':')[1]
    const server = servers.find(s => s.id === id)
    return server?.name ?? 'Server'
  }
  switch (route) {
    case 'dashboard': return 'Dashboard'
    case 'players': return 'Players'
    case 'plugins': return 'Plugins'
    case 'backups': return 'Backups'
    case 'audit': return 'Audit Log'
    case 'settings': return 'Settings'
    default: return 'mcpanel'
  }
}

export function Topbar({ route, servers, role, viewer, onMenuClick }: TopbarProps) {
  return (
    <header className="topbar">
      <button className="topbar-menu" onClick={onMenuClick} aria-label="Open navigation">
        <Icon name="menu" size={20} />
      </button>
      <div className="topbar-title">{titleFor(route, servers)}</div>
      <div className="topbar-user">
        <Avatar user={viewer} size={28} />
        <span className="topbar-role">{role.charAt(0).toUpperCase() + role.slice(1)}</span>
      </div>
    </header>
  )
}
